import type { IBinder } from '@monofe/di';
import { buildBinderListings } from '@monofe/di';

import browserBind from '../impl/browser.bind';
import cacheBind from '../impl/cache.bind';
import cachecontrollerBind from '../impl/cachecontroller.bind';
import envBind from '../impl/env.bind';
import featureQueryBind from '../impl/featureQuery.bind';
import fetchBind from '../impl/fetch.bind';
import kvStorageBind from '../impl/kvStorage.bind';
import logBind from '../impl/log.bind';
import mimeTypeBind from '../impl/mimeType.bind';
import promiseBind from '../impl/promise.bind';
import querystringBind from '../impl/querystring.bind';
import translationstorageBind from '../impl/translationstorage.bind';
import zipBind from '../impl/zip.bind';

const BINDER_LOADERS: (Readonly<IBinder<unknown>> & { private?: boolean })[] = [
    browserBind,
    cacheBind,
    cachecontrollerBind,
    envBind,
    featureQueryBind,
    fetchBind,
    kvStorageBind,
    logBind,
    mimeTypeBind,
    promiseBind,
    querystringBind,
    translationstorageBind,
    zipBind,
];

export default buildBinderListings(BINDER_LOADERS);
